import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Table } from "../../../Components/Table/Table";
import { getSalaryList, deleteSalary } from "../../../api/salary";

const AdminSalary = () => {
  const [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);
  const [employeeId, setEmployeeId] = useState("");

  const navigate = useNavigate();

  /* ================= FETCH ================= */
  const fetchSalary = async (searchId = "") => {
    try {
      const res = await getSalaryList(
        searchId ? { employeeId: searchId } : {}
      );

      const formatted = res.data.data.map((item, index) => ({
        ...item,
        sno: index + 1,
      }));

      setData(formatted);
    } catch (err) {
    }
  };

  useEffect(() => {
    fetchSalary();
  }, []);

  /* ================= DELETE ================= */
 const handleDelete = useCallback(async (id) => {
  if (!window.confirm("Are you sure?")) return;

  await deleteSalary(id);
  fetchSalary(employeeId);
}, [employeeId]);

  /* ================= COLUMNS ================= */
  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "sno" },
      { Header: "Emp ID", accessor: "employeeId" },
      { Header: "Name", accessor: "employeeName" },
      { Header: "Month", accessor: "month" }, // ✅ NEW
      { Header: "Year", accessor: "year" }, // ✅ NEW
      { Header: "Credit Date", accessor: "creditDate" },
      { Header: "Time", accessor: "creditTime" },
      { Header: "Amount", accessor: "amount" },
      { Header: "Company Bank", accessor: "companyBank" },
      { Header: "Employee Bank", accessor: "employeeBank" },
      { Header: "Status", accessor: "status" },

      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div>
            <EditIcon
              style={{ cursor: "pointer", marginRight: 10 }}
              onClick={() =>
                navigate(`/create-salary-details/${row.original._id}`)
              }
            />
            <DeleteIcon
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(row.original._id)}
            />
          </div>
        ),
      },
     ],
  [navigate, handleDelete] 
  );

  return (
    <div className="p-3 mt-3">

      {/* HEADER */}
      <div className="d-flex justify-content-between mb-3">
        <h3>Salary List</h3>
       <button
  onClick={() => navigate("/create-salary-details")}
  className="add-salary-btn"
>
  <span>+</span> Add Salary
</button>
      </div>

      {/* SEARCH */}
      <div className="d-flex mb-3">
        <input
          className="custom-input"
          placeholder="Search Employee ID"
          value={employeeId}
          onChange={(e) => setEmployeeId(e.target.value)}
        />
        <button onClick={() => fetchSalary(employeeId)}  className="search-button">Search</button>
      </div>
  
      {/* TABLE */}
      <Table
        columns={columns}
        data={data}
        pageno={pageno}
        setPageno={setPageno}
        show
      />
    </div>
  );
};

export default AdminSalary;